<template>
  <div :class="bem.b()">
    <RadioGroup v-model:value="type">
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.unset" v-bind="beforeRadioAttrs">
          不设置
        </Radio>
        <span>日和周只能设置其中之一</span>
      </div>
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.every" v-bind="beforeRadioAttrs"> 每日 </Radio>
      </div>
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.range" v-bind="beforeRadioAttrs"> 区间 </Radio>
        <span>从</span>
        <InputNumber v-model:value="valueRange.start" v-bind="typeRangeAttrs" />
        <span>日 至</span>
        <InputNumber v-model:value="valueRange.end" v-bind="typeRangeAttrs" />
        <span>日</span>
      </div>
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.loop" v-bind="beforeRadioAttrs">循环</Radio>
        <span>从</span>
        <InputNumber v-model:value="valueLoop.start" v-bind="typeLoopAttrs" />
        <span>日开始，间隔</span>
        <InputNumber
          v-model:value="valueLoop.interval"
          v-bind="typeLoopAttrs"
        />
        <span>日</span>
      </div>
      <div :class="bem.m('item')">
        <Radio :value="TypeEnum.last" v-bind="beforeRadioAttrs">
          最后一日
        </Radio>
      </div>
      <div :class="`${bem.m('item')} ${bem.m('item-checkbox')}`">
        <Radio :value="TypeEnum.specify" v-bind="beforeRadioAttrs">
          指定
        </Radio>
        <div :class="bem.e('list')">
          <CheckboxGroup v-model:value="valueList">
            <template v-for="i in specifyRange" :key="i">
              <Checkbox :value="i" v-bind="typeSpecifyAttrs">
                {{ i }}
              </Checkbox>
            </template>
          </CheckboxGroup>
        </div>
      </div>
    </RadioGroup>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, watch } from 'vue'
import {
  InputNumber,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
} from 'ant-design-vue'

import {
  TypeEnum,
  useTabEmits,
  useTabProps,
  useTabSetup,
} from '../../config/use-tab-mixin'

export default defineComponent({
  name: 'DayUI',
  components: { InputNumber, RadioGroup, Radio, CheckboxGroup, Checkbox },
  props: {
    ...useTabProps({
      defaultValue: '*',
    }),
    week: {
      type: String,
      default: '?',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: useTabEmits(),
  setup(props, context) {
    const disabledChoice = computed(() => {
      return (props.week && props.week !== '?') || props.disabled
    })
    const setup = useTabSetup(props, context, {
      defaultValue: '*',
      valueWork: 1,
      minValue: 1,
      maxValue: 31,
      valueRange: { start: 1, end: 31 },
      valueLoop: { start: 1, interval: 1 },
      disabled: disabledChoice,
    })
    const typeWorkAttrs = computed(() => ({
      disabled:
        setup.type.value !== TypeEnum.work ||
        props.disabled ||
        disabledChoice.value,
      ...setup.inputNumberAttrs.value,
    }))

    watch(
      () => props.week,
      () => {
        setup.updateValue(disabledChoice.value ? '?' : setup.computeValue.value)
      }
    )

    return { ...setup, typeWorkAttrs }
  },
})
</script>
